import type { FC } from 'react'
import { useState } from 'react'
import styled from 'styled-components'

import Lightbox, { getFile } from '@/components/Lightbox'
import type { SupportingDocument as SupportingDocumentT } from '@/types/Activity'
import { useUserTracking } from '@/utils/tracking'

interface Props {
  supportingDocuments: SupportingDocumentT[]
  customerId: string
  subjectId: string
}

const Container = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, 150px);
`

const SupportingDocument = styled.div`
  display: grid;
  grid-template-rows: 1fr min-content;
  grid-gap: 5px;
`

const Proof = styled.img`
  max-width: 100%;
  max-width: 125px;
  height: auto;
  border-radius: 10px;
  flex: 1;
  object-fit: contain;
`

const SupportingDocuments: FC<Props> = ({
  supportingDocuments,
  customerId,
  subjectId,
}) => {
  const { trackUserActivity } = useUserTracking()

  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [imageIndex, setImageIndex] = useState(0)
  const handleImageClicked = (imageIndex: number) => {
    setImageIndex(imageIndex)
    setLightboxOpen(true)
    trackUserActivity('View document', {
      subjectId,
      customerId,
      fileName: getFile(supportingDocuments[imageIndex]),
    })
  }

  return (
    <>
      {lightboxOpen && supportingDocuments && (
        <Lightbox
          images={supportingDocuments}
          onClose={() => setLightboxOpen(false)}
          startIndex={imageIndex}
          customerId={customerId}
          subjectId={subjectId}
        />
      )}
      <Container>
        {supportingDocuments.map(({ type, thumbnail }, docIndex) => (
          <SupportingDocument key={docIndex} onClick={() => handleImageClicked(docIndex)}>
            <div>
              <Proof src={thumbnail} alt={`A ${type} Document`} />
            </div>
            <div>Document Type: {type}</div>
          </SupportingDocument>
        ))}
      </Container>
    </>
  )
}

export default SupportingDocuments
